var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15.3 19.8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-guidelines",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconography",
    transform: "translate(-409.000000, -680.000000)",
    className: "svg-path2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Share",
    transform: "translate(392.000000, 665.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    d: "M18.9660351,22.7856359 C19.6393685,22.6204508 20.3159117,22.7357594 20.8717141,23.0567471 L27.1608499,18.6355125 C27.0993685,18.4977347 27.0487512,18.351068 27.0114672,18.1982285 C26.6709734,16.8137841 27.517887,15.4160063 28.9020845,15.0752656 C30.2867759,14.7347717 31.6852944,15.5816853 32.0250475,16.9663767 C32.3655413,18.351068 31.5186277,19.7490927 30.1344302,20.0890927 C29.3015907,20.294031 28.4640598,20.0695866 27.854924,19.5565001 L21.7312203,23.8616853 C21.892208,24.1039075 22.0156647,24.3774878 22.0887512,24.6765001 C22.249245,25.3300804 22.1450475,25.9856359 21.8457882,26.5323026 L27.8652944,30.3979816 C28.1897388,30.0693396 28.6055413,29.8234137 29.0870228,29.7051421 C30.4714672,29.3651421 31.8697388,30.211315 32.2097388,31.5957594 C32.5502327,32.9809446 31.7040598,34.3787224 30.3188746,34.7194631 C28.9341833,35.0592162 27.5366524,34.2130434 27.1961586,32.8285989 C27.0736894,32.3305742 27.1050475,31.831068 27.2591215,31.3789693 L21.0682573,27.4034137 C20.8129487,27.5844014 20.5201092,27.7204508 20.1981339,27.7999569 C18.8134425,28.13971 17.4151709,27.2935372 17.0754178,25.9088458 C16.7346771,24.5236606 17.580603,23.1261298 18.9660351,22.7856359 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.346fb2e7beb01db60aaf2f01bf2ac3ed.svg";
export { ForwardRef as ReactComponent };